import SimpleButton from "./SimpleButton";

export const Button = {
    Simple: SimpleButton,
};
